
















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import CustomDialog from '@/components/custom-dialog/index.vue'

export default Vue.extend({
  name: 'TagBrowser',
  props: {
    value: String,
  },
  components: {
    CustomDialog,
  },
  data() {
    return {
      selectedIndex: '-1',
      visible: false,
    }
  },
  computed: {
    ...mapGetters('tag', ['items']),
  },

  methods: {
    handleOk() {
      this.$emit('input', this.items[this.selectedIndex].uid)
      this.$emit('ok', this.items[this.selectedIndex])
      this.selectedIndex = '-1'
    },

    parseValue() {
      this.selectedIndex = this.value
    },
  },

  watch: {
    visible: function() {
      this.parseValue()
    },
    value: function() {
      this.parseValue()
    },
  },

  mounted() {
    this.parseValue()
  },
})
